import { getMultimediaBlockProgress } from 'api/lessons/block-instances/GetMultimediaBlockProgress'

export const getDefaultProgress = () => ({
  duration: NaN,
  currentTime: 0,
})

export type PayloadGetLessonBlockProgress = {
  id: number
  blockInstanceableId: number
  courseId: number
}

export async function getInitialContentProgress({
  blockInstanceableId,
  courseId,
}: PayloadGetLessonBlockProgress) {
  const data = await getMultimediaBlockProgress(
    blockInstanceableId,
    courseId
  ).catch(() => null)

  if (!data) return getDefaultProgress()

  return {
    duration: +data.duration,
    currentTime: +data.progress,
  }
}
